import React from 'react'

export default function JoinConsultation() {
  return (
    <div className=' bg-[rgba(19,19,19,1)] py-2 px-4 text-white flex flex-wrap relative '>
      <div className=' flex flex-wrap text-center mx-auto whitespace-break-spaces text-sm mg-text-base '>
        <p className='mx-auto line-clamp-1'> Join Our Free Gen Consultation. Request a callback </p>
        <p className='flex mx-auto'>
               <a href='tel:7398331119' className=' text-yellow-500'>+91 7398331119 </a> 
        </p>
      </div>
    </div>
  )
}
